import React from "react";

const BulkUpdateRow = React.memo(({ 
  item, idx, activeTab, selectedIds, categories, units, taxes,
  toggleOne, updatePricingField, updateStockField, updateItemInfoField 
}) => {
  return (
    <tr>
      <td>
        <input
          type="checkbox"
          checked={selectedIds.has(item.itemId)}
          onChange={() => toggleOne(item.itemId)}
        />
      </td>
      <td>{idx + 1}</td>
      <td style={{ fontWeight: 500 }}>{item.itemName}</td>

      {activeTab === "Pricing" && (
        <>
          <td>
            <select className="form-control form-control-sm" value={item.categoryId || ""}
              onChange={(e) => updatePricingField(item, "categoryId", e.target.value ? Number(e.target.value) : null)}>
              <option value="">---</option>
              {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </td>
          <td>
            <input className="form-control form-control-sm" value={item.itemHsn || ""} placeholder="---"
              onChange={(e) => updatePricingField(item, "itemHsn", e.target.value)} />
          </td>
          <td>
            <input type="number" className="form-control form-control-sm" value={item.purchasePrice ?? ""} placeholder="---"
              onChange={(e) => updatePricingField(item, "purchasePrice", e.target.value ? Number(e.target.value) : null)} />
          </td>
          <td>
            <select className="form-control form-control-sm" value={item.purchasePriceTaxType || "With Tax"}
              onChange={(e) => updatePricingField(item, "purchasePriceTaxType", e.target.value)}>
              <option>With Tax</option>
              <option>Without Tax</option>
            </select>
          </td>
          <td>
            <input type="number" className="form-control form-control-sm" value={item.salePrice ?? ""}
              onChange={(e) => updatePricingField(item, "salePrice", e.target.value ? Number(e.target.value) : null)} />
          </td>
          <td>
            <select className="form-control form-control-sm" value={item.salePriceTaxType || "With Tax"}
              onChange={(e) => updatePricingField(item, "salePriceTaxType", e.target.value)}>
              <option>With Tax</option>
              <option>Without Tax</option>
            </select>
          </td>
          <td>
            <input type="number" className="form-control form-control-sm" value={item.discountOnSale ?? ""} placeholder="---"
              onChange={(e) => updatePricingField(item, "discountOnSale", e.target.value ? Number(e.target.value) : null)} />
          </td>
          <td>
            <select className="form-control form-control-sm" value={item.discountType || "Percentage"}
              onChange={(e) => updatePricingField(item, "discountType", e.target.value)}>
              <option>Percentage</option>
              <option>Fixed</option>
            </select>
          </td>
          <td>
            <select className="form-control form-control-sm" value={item.taxId || ""}
              onChange={(e) => updatePricingField(item, "taxId", e.target.value ? Number(e.target.value) : null)}>
              <option value="">---</option>
              {taxes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </td>
        </>
      )}

      {activeTab === "Stock" && (
        <>
          <td>
            <input type="number" className="form-control form-control-sm" value={item.openingStock ?? ""} placeholder="---"
              onChange={(e) => updateStockField(item, "openingStock", e.target.value ? Number(e.target.value) : null)} />
          </td>
          <td>
            <input type="number" className="form-control form-control-sm" value={item.stockAtPrice ?? ""} placeholder="---"
              onChange={(e) => updateStockField(item, "stockAtPrice", e.target.value ? Number(e.target.value) : null)} />
          </td>
          <td>
            <input type="date" className="form-control form-control-sm" value={item.stockAsOfDate || ""}
              onChange={(e) => updateStockField(item, "stockAsOfDate", e.target.value)} />
          </td>
          <td>
            <input type="number" className="form-control form-control-sm" value={item.minStockQty ?? ""} placeholder="---"
              onChange={(e) => updateStockField(item, "minStockQty", e.target.value ? Number(e.target.value) : null)} />
          </td>
          <td>
            <input className="form-control form-control-sm" value={item.location || ""} placeholder="---"
              onChange={(e) => updateStockField(item, "location", e.target.value)} />
          </td>
        </>
      )}

      {activeTab === "ItemInfo" && (
        <>
          <td>
            <input className="form-control form-control-sm" value={item.itemHsn || ""} placeholder="---"
              onChange={(e) => updateItemInfoField(item, "itemHsn", e.target.value)} />
          </td>
          <td>
            <select className="form-control form-control-sm" value={item.categoryId || ""}
              onChange={(e) => updateItemInfoField(item, "categoryId", e.target.value ? Number(e.target.value) : null)}>
              <option value="">---</option>
              {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </td>
          <td>
            <select className="form-control form-control-sm" value={item.unitId || ""}
              onChange={(e) => updateItemInfoField(item, "unitId", e.target.value ? Number(e.target.value) : null)}>
              <option value="">---</option>
              {units.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
            </select>
          </td>
        </>
      )}
    </tr>
  );
});

export default BulkUpdateRow;